import React from 'react';
import { Button, CONTAINED_VARIANT, NO_ICON, SIZE_44 } from '@yme/atoms/button';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel2, RegularTextLevel3 } from '@yme/tokens/typography';
import { ButtonLinkWrapper } from '../buttons';
import { HeadingLevel4Styled, PromotionalBannerDescriptionStyled } from './styled';
export function PromotionalBannerDescription(props) {
    const { title, subtitle, link, description } = props;
    const { t } = useTranslation();
    return (React.createElement(PromotionalBannerDescriptionStyled, { flexDirection: "column", gap: "16px" },
        React.createElement(FlexWrapper, { flexDirection: "column", gap: "4px" },
            React.createElement(HeadingLevel4Styled, { color: colorCoreBlack300 }, subtitle),
            React.createElement(HeadingLevel2, null, title)),
        React.createElement(FlexWrapper, { flexDirection: "column", gap: "32px" },
            React.createElement(RegularTextLevel3, null, description),
            React.createElement(ButtonLinkWrapper, { buttonLink: link },
                React.createElement(Button, { buttonVariant: CONTAINED_VARIANT, hasIconButton: NO_ICON, size: SIZE_44, label: t('common_learnMore_link') })))));
}
